<template>
  <div id="app">
    <AppSplashScreen v-if="isLoading" />
    <v-main style="height: 100%;  min-width: 300px;" v-else>
      <router-view />
    </v-main>
  </div>
</template>

<script>
import AppSplashScreen from '@/components/AppSplashScreen.vue';
export default {
  data: () => ({
    drawer: null,
    isLoading: true,
  }),
  components: {
    AppSplashScreen,
  },
  mounted() {
    setTimeout(() => {
      this.isLoading = false;
    }, 3000);
  },
};
</script>
